<template>
    <Modal :show="!!station" @close="closeStation()">
        <div class="flex justify-center">
            <h2 class="inline-block text-5xl">
                {{ $t('messages.victory!') }}
            </h2>
        </div>
        <div class="flex justify-center">
            <img class="w-40 h-40 object-contain" :src="station.image" alt="" />
        </div>
        <div v-if="station.description" class="py-2">
            <p class="text-sm text-gray-700 whitespace-pre-line prose prose-sm" v-html="station.description" />
        </div>
        <div>
            <div class="mt-1">
                <div class="flex gap-x-2 items-center">
                    <div>
                        <BadgePill color="green" v-show="point.points">
                            {{ point.points }}
                        </BadgePill>
                    </div>
                    <div>
                        <BadgePill color="yellow" v-show="point.coins_points">
                            {{ point.coins_points }}
                        </BadgePill>
                    </div>
                </div>
            </div>
        </div>
    </Modal>
    <Teleport to="body">
        <div class="relative z-20 pointer-events-none">
            <div class="fixed z-10 inset-0">
                <div class="flex items-end items-center justify-center min-h-full p-4">
                    <ConfettiExplosion v-if="showConfetti" />
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
    name: 'FinalStationModal',
    components: {
        Modal,
    },
};
</script>

<script setup>
import axios from 'axios';

let emit = defineEmits(['close']);
import { computed, ref, watch } from 'vue';
import { Howl } from 'howler';
import BadgePill from '@/components/BadgePill.vue';
import ConfettiExplosion from 'vue-confetti-explosion';
const showConfetti = ref(false);

const props = defineProps({
    station: {
        type: Object,
    },
});

const stationTitle = computed(() => {
    return props.station ? props.station.display_name : null;
});

const point = ref({
    points: null,
    coins_points: null,
    items: [],
});
const isMarkedForUpdate = ref(false);

const markAsForUpdate = () => {
    isMarkedForUpdate.value = true;
};

setTimeout(() => {
    markAsForUpdate();
}, 1000);

setTimeout(() => {
    const sound = new Howl({
        src: ['/assets/gamification/victory.mp3'],
    });
    sound.play();
    if (!props.station.completed_at) {
        completeFinalStation();
    }
    showConfetti.value = true;
}, 1500);

function completeFinalStation() {
    if (!props.station.completed_at) {
        axios.patch(props.station.links.complete).then((response) => {
            point.value.points = response.data.point.points;
            point.value.coins_points = response.data.point.coins_points;
        });
    }
}

const initialize = () => {
    axios.patch(props.station.links.initialize);
};

watch(
    () => props.station,
    (currentStation) => {
        if (currentStation) {
            initialize();
        }
    },
    { immediate: true },
);

const closeStation = () => {
    emit('close', isMarkedForUpdate.value);
};
</script>
